import React, { useEffect, useState } from 'react';
import './reference.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { useSearchParams } from 'react-router';
import {
  getFilterData,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { getReferenceInformationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  deleteRegistryOfSuspensionReasons,
  loadRegistryOfSuspensionReasonsById,
  loadRegistryOfSuspensionReasonsList,
} from '../actions';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { dateFormatter, localeFormatter, userPositionFormatter } from '../../../utils/formatters';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import RegistryOfSuspensionReasonsDTO from '../../../dto/RegistryOfSuspensionReasonsDTO';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { showGlobalConfirm } from '../../System/actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { REASON_TYPE_LIST } from '../../../configs';
import RegistryOfSuspensionReasonsPageForm from './RegistryOfSuspensionReasonsPageForm';
import RegistryOfSuspensionReasonsView from './RegistryOfSuspensionReasonsView';
import { REFERENCE_INFORMATION_MODULE } from '../../../configs/moduleNames';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import { loadUserList } from '../../User/actions';
import getDefaultSort from '../../../utils/getDefaultSort';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function RegistryOfSuspensionReasonsPage() {
  const dispatch = useDispatch();
  const store = useStore();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [isShowForm, setIsShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { updatePeriod } = useSelector(getSystemData);
  const DTO = new RegistryOfSuspensionReasonsDTO();
  const [searchParams, setSearchParams] = useSearchParams();
  const isNew = searchParams.get('new');
  useEffect(() => setIsShowForm(!!isNew), [isNew]);
  const attributes = DTO.getAttributesByName();
  const suspensionReasonColumns = [
    {
      dataField: 'name',
      text: 'Наименование основания',
      headerClassName: 'reason-name-column',
    },
    {
      dataField: 'reasons_types',
      text: 'Тип',
      headerClassName: 'applicable-object-column',
      formatter: items => items?.map(item => localeFormatter('reason.type', item)).join(', '),
    },
    {
      dataField: 'created_at',
      text: 'Дата создания',
      headerClassName: 'creation-date-column',
      formatter: dateFormatter,
    },
    {
      dataField: 'creator',
      text: 'Автор',
      headerClassName: 'author-column',
      formatter: userPositionFormatter,
    },
  ];
  const [sort, setSort] = useState(getDefaultSort(suspensionReasonColumns));
  const {
    registryOfSuspensionReasons = {},
    registryOfSuspensionReasonsList = [],
    registryOfSuspensionReasonsListMeta,
    loadingRegistryOfSuspensionReasonsList = {},
  } = useSelector(getReferenceInformationData);
  const { formatMessage } = useIntl();
  const {
    getValues, control, watch, setValue,
  } = useForm({ defaultValues: getFilterData('rsr-filter', {}) });
  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[REFERENCE_INFORMATION_MODULE].registryOfSuspensionReasonsListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: filterData,
      sort,
    };
    const p1 = dispatch(loadRegistryOfSuspensionReasonsList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const handleEdit = item => event => {
    if (!item) {
      return;
    }
    dispatch(loadRegistryOfSuspensionReasonsById(item.id))
      .then(() => {
        setIsShowForm(true);
        setIsEdit(true);
      })
      .catch(response => errorNotification('Загрузка записи', getResponseError(response)));
    return false;
  };

  const handleClose = () => {
    setIsShowForm(false);
    setIsEdit(false);
    setIsShow(false);
  };

  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  useEffect(() => {
    const subscription = watch(values => loadData({ page: 1 }));
    return () => subscription.unsubscribe();
  }, [watch]);

  const handleShow = item => event => {
    if (!item) {
      return;
    }
    dispatch(loadRegistryOfSuspensionReasonsById(item.id))
      .then(() => {
        setIsShow(true);
      })
      .catch(response => errorNotification('Загрузка записи', getResponseError(response)));
    return false;
  };

  const renderContextMenu = item => (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button">
        Копировать ссылку
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={handleShow(item)}>
        Просмотреть
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
        Редактировать
      </Button>
    </div>
  );

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление основания "${item.name || ''}"`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteRegistryOfSuspensionReasons(item.id)).then(() => {
        loadData();
        successNotification('Удаление основания', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление основания', getResponseError(response));
      });
    }).catch(() => {});
    return false;
  };
  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);
  return (
    <div className="page rsr-page">
      <TimerLoader loading={loadingRegistryOfSuspensionReasonsList} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.reference.common.reason' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={attributes.reasons_types}
            usePortal
            multiple
            className="no-border"
            addPlaceholder
            options={REASON_TYPE_LIST}
          />
          <div className="filter-sep" />
          <FieldDTO
            control={control}
            dtoObject={attributes.creator_id}
            usePortal
            className="no-border"
            addPlaceholder
            component={CustomSelectInputWithHelper}
            portalClassName="executor-selector"
            loadAction={loadUserList}
            optionFormatter={item => ({ value: item.id, name: item.full_name })}
            filterName="full_name"
          />
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setIsShowForm(true)}>
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="plus"
            />
          </Button>
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                onDoubleClickByRow={(item, event) => handleShow(item)(event)}
                rowClassFormatter={item => (selectedRow && item.id === selectedRow.id ? 'clickable-table-row selected' : 'clickable-table-row')}
                data={registryOfSuspensionReasonsList}
                columns={suspensionReasonColumns}
                name="rsr-grid"
                className="rsr-grid"
                settingsFormatter={moreFormatter}
                renderContextMenu={renderContextMenu}
                changeSort={changeSort}
                sort={sort}
              />
            </div>
          </div>
          <Pagination meta={registryOfSuspensionReasonsListMeta} list={registryOfSuspensionReasonsList} handleChangeMeta={loadData} />
        </div>
      </div>
      { isShowForm ? <RegistryOfSuspensionReasonsPageForm key={registryOfSuspensionReasons && registryOfSuspensionReasons.id} isEdit={isEdit} current={registryOfSuspensionReasons} loadData={loadData} close={handleClose} /> : null}
      { isShow ? <RegistryOfSuspensionReasonsView setIsShowForm={setIsShowForm} setIsEdit={setIsEdit} key={registryOfSuspensionReasons && registryOfSuspensionReasons.id} current={registryOfSuspensionReasons} handleDelete={handleDelete} close={handleClose} /> : null}
    </div>
  );
}
